import { render, staticRenderFns } from "./SwitchboardRoom.vue?vue&type=template&id=5b9fd8fc&scoped=true&"
import script from "./SwitchboardRoom.vue?vue&type=script&lang=ts&"
export * from "./SwitchboardRoom.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchboardRoom.vue?vue&type=style&index=0&id=5b9fd8fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9fd8fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VContainer,VIcon})
